import { z } from 'zod';
import { APP_CONSTRAINTS } from '@/lib/constants/app';

const optionalHttpUrl = z
  .string()
  .max(APP_CONSTRAINTS.LISTING_URL_MAX)
  .refine((v) => v === '' || /^https?:\/\/\S+\.\S+/.test(v), 'Enter a valid URL (https://...)');

const optionalEmail = z
  .string()
  .max(APP_CONSTRAINTS.LISTING_EMAIL_MAX)
  .refine((v) => v === '' || /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v), 'Enter a valid email address');

export interface AppListingFormSchemaOpts {
  /**
   * The active platforms whose store needs the age rating before the first
   * version is submitted, by label (AppPlatformUtils.platformsRequiringAgeRating);
   * empty = the rating stays optional.
   */
  ageRatingRequiredFor: string[];
}

export function appListingFormSchema({ ageRatingRequiredFor }: AppListingFormSchemaOpts = { ageRatingRequiredFor: [] }) {
  return z.object({
    privacyPolicyUrl: optionalHttpUrl,
    termsUrl: optionalHttpUrl,
    ageRating: z
      .string()
      .max(APP_CONSTRAINTS.LISTING_AGE_RATING_MAX)
      .refine(
        (v) => ageRatingRequiredFor.length === 0 || v.trim() !== '',
        `Choose an age rating: ${ageRatingRequiredFor.join(' and ')} requires one`,
      ),
    supportEmail: optionalEmail,
    supportPhone: z.string().max(APP_CONSTRAINTS.LISTING_PHONE_MAX),
    supportUrl: optionalHttpUrl,
    appAdsTxtUrl: optionalHttpUrl,
  });
}

export type AppListingFormSchemaData = z.infer<ReturnType<typeof appListingFormSchema>>;
